import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { PRODUCT_IMAGE } from './data';
const names = ['Matías', 'Federico', 'Lucas', 'Ignacio', 'Santiago', 'Tomás', 'Agustín', 'Facundo', 'Nicolás', 'Martín'];
const cities = ['Córdoba', 'CABA', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Santa Fe'];
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setBuyer({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(triggerPopup, 3000);
    // Recurring interval (every 15-25 seconds)
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-145">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-3 flex items-center gap-4 pr-10" data-id="element-146">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-zinc-500 hover:text-zinc-300" data-id="element-147">
            <X className="w-4 h-4" data-id="element-148" />
          </button>

          <img src={PRODUCT_IMAGE} alt="Product" className="w-12 h-16 object-cover rounded shadow-sm" data-id="element-149" />

          <div data-id="element-150">
            <p className="text-sm text-zinc-200 leading-tight" data-id="element-151">
              <span className="font-bold text-white" data-id="element-152">{buyer.name}</span> de{' '}
              {buyer.city} acaba de comprar{' '}
              <span className="text-amber-400 font-medium" data-id="element-153">
                Artista Marcial Completo
              </span>
            </p>
            <p className="text-xs text-zinc-500 mt-1" data-id="element-154">
              hace {buyer.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}